"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _semanticUiReact = require("semantic-ui-react");
var _classnames = _interopRequireDefault(require("classnames"));
var _moment = _interopRequireDefault(require("moment"));
var R = _interopRequireWildcard(require("ramda"));
var _uuid = require("uuid");
var _pluralTranslations = require("../../../../../localization/pluralTranslations");
var _Tooltip = _interopRequireWildcard(require("../../../../ui/Tooltip"));
var _Button = _interopRequireWildcard(require("../../../../ui/Button"));
var _selectors = require("../../store/selectors");
var _hooks = require("../../hooks");
var _styles = _interopRequireDefault(require("../../styles.scss"));
var _plus = _interopRequireDefault(require("../../icons/plus.svg"));
var _helpers = require("./helpers");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var Clients = function Clients(_ref) {
  var adults = _ref.adults,
    child = _ref.child,
    claimID = _ref.claimID,
    clientID = _ref.clientID,
    dateStart = _ref.dateStart,
    name = _ref.name,
    nights = _ref.nights,
    performer = _ref.performer,
    title = _ref.title,
    claimIndex = _ref.claimIndex,
    onSave = _ref.onSave,
    showAddNewClaimButton = _ref.showAddNewClaimButton;
  var _useTranslation = (0, _reactI18next.useTranslation)('SAVE_TO_CLAIM_MODAL'),
    t = _useTranslation.t;
  var nightsTranslation = (0, _pluralTranslations.usePluralNightsTranslation)();
  var touristsTranslation = (0, _pluralTranslations.usePluralTouristsTranslation)();
  var indicatorsKey = (0, _react.useMemo)(function () {
    return (0, _uuid.v4)();
  }, []);
  var indicatorsSelector = (0, _react.useMemo)(function () {
    return R.partialRight((0, _selectors.getSavingClaimIndicatorsByKey)(), [{
      indicatorsKey: indicatorsKey
    }]);
  }, [indicatorsKey]);
  var indicators = (0, _reactRedux.useSelector)(indicatorsSelector);
  var callbacks = (0, _hooks.useCallbacksForSave)(indicatorsKey);
  var shouldRenderPeople = Boolean(adults || child);
  return /*#__PURE__*/_react.default.createElement(_semanticUiReact.Dimmer.Dimmable, {
    className: _styles.default.item,
    dimmed: indicators.success
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.row
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_styles.default.col, _styles.default.col1)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.title
  }, name), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.desc
  }, performer)), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_styles.default.col, _styles.default.col2)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.claimWrapper
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.col2body
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.title
  }, title), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.desc
  }, dateStart && t('OFFER_DATE_INFO_TEXT', {
    date: (0, _moment.default)(dateStart).format('D MMMM')
  }), Boolean(nights) && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, ' ', nights, ' ', nightsTranslation(nights)), Boolean(nights) && shouldRenderPeople && ', ', shouldRenderPeople && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, adults, ' + ', child, ' ', touristsTranslation(adults + child)))), /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    content: t('SAVE_TO_CLAIM_HINT'),
    placement: _Tooltip.PLACEMENTS.TOP,
    trigger: [_Tooltip.TRIGGERS.HOVER]
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    circle: true,
    className: _styles.default.circleButton,
    disabled: indicators.loading,
    icon: _plus.default,
    iconClassName: _styles.default.plusIcon,
    theme: _Button.THEMES.GRAY,
    onClick: function onClick() {
      return onSave({
        claimID: claimID,
        clientID: clientID,
        claimIndex: claimIndex,
        callbacks: callbacks
      });
    }
  }))), showAddNewClaimButton && /*#__PURE__*/_react.default.createElement(_Button.default, {
    disabled: indicators.loading,
    theme: _Button.THEMES.GRAY,
    onClick: function onClick() {
      return onSave({
        clientID: clientID,
        claimIndex: claimIndex,
        callbacks: callbacks
      });
    }
  }, t('ADD_TO_NEW_CLAIM_BUTTON')))), indicators.success && /*#__PURE__*/_react.default.createElement(_semanticUiReact.Dimmer, {
    active: true,
    inverted: true,
    className: _styles.default.dimmer
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Message, null, t('SUCCESS_SAVED_MESSAGE_TEXT'), ', ', /*#__PURE__*/_react.default.createElement("a", {
    href: (0, _helpers.generateClaimLink)(clientID, claimID),
    rel: "noopener noreferrer",
    target: "_blank"
  }, t('TO_CLAIM_LINK'))))), indicators.loading && /*#__PURE__*/_react.default.createElement(_semanticUiReact.Dimmer, {
    active: true,
    inverted: true
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Loader, null))), indicators.error && /*#__PURE__*/_react.default.createElement(_semanticUiReact.Dimmer, {
    active: true,
    inverted: true
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Message, {
    error: true,
    visible: true,
    header: indicators.error.message
  }))));
};
Clients.propTypes = {
  onSave: _propTypes.default.func.isRequired,
  claimIndex: _propTypes.default.number.isRequired,
  showAddNewClaimButton: _propTypes.default.bool,
  adults: _propTypes.default.number,
  child: _propTypes.default.number,
  claimID: _propTypes.default.any,
  clientID: _propTypes.default.any,
  dateStart: _propTypes.default.func,
  name: _propTypes.default.string,
  nights: _propTypes.default.number,
  performer: _propTypes.default.string,
  title: _propTypes.default.string
};
Clients.defaultProps = {
  adults: 0,
  child: 0
};
var _default = exports.default = (0, _react.memo)(Clients);